export default __webpack_public_path__ + "static/Amanda Pacífico_MiniBio-14a7abcda4532d92d8fd65549a986b63.webp";